import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=5d39a1c0&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=5d39a1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d39a1c0",
  null
  
)

export default component.exports